import { EDITMEMBERTIMETRACKER_SUCCESS, EDITMEMBERTIMETRACKER_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const editMemberTimetrackerReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDITMEMBERTIMETRACKER_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case EDITMEMBERTIMETRACKER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default editMemberTimetrackerReducer;
